import GlobalConst from "../../constants/GlobalConst";
import Account from "../../entities/Account";
import {createSelector} from "@reduxjs/toolkit";
import Transfer from "../../entities/Transfer";

export const selectUserAccount = createSelector(
    state => state.account?.userAccount,
    userAccount => Account.fromJs(userAccount)
)
export const selectToken = state => state.account.token;
export const selectUserLanguage = state => state.account?.userAccount?.preferences?.culture ?? GlobalConst.SITE_LANG;
export const selectLocale = state => selectUserLanguage(state)?.split('-')[0] ?? 'en';
export const selectUserPictureUrl = (state, accountId) => {
    const account = selectUserAccount(state);
    if (!account) return null;
    let qs = "";
    if (accountId === account.accountId && state.account.lastPictureUpdate !== "")
        qs = "?v=" + state.account.lastPictureUpdate;
    return `${GlobalConst.CDN.BASEURL}Users/${accountId}.png${qs}`;
}
export const selectUserAccountId = state => state.account?.userAccount?.accountId;
export const selectUserIsAuthenticated = state => state.account?.userAccount?.accountId > 0;
export const selectUserAvailableBalance = state => state.account?.userAccount?.availableBalance;
export const selectUserCultureLg = state => selectUserAccount(state)?.preferences.culture.split('-')[0];
export const selectUserLocation = state => state.account?.userAccount?.address;
// export const selectUserCultureLg = state => selectUserAccount(state).cultureLg;

export const selectUserRegistrationError = state => state.account.userRegistration.error;
export const selectUserAccountProfileState = state => state.account.userAccountProfileState;

// User Transactions ---------------------

export const selectUserTransactions = createSelector(
    state => state.account?.userTransactions,
     userTransactions => userTransactions.map(t => Transfer.fromJson(t))
)